import { t, Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { Portal } from "components/portal/Portal";
import React, { FunctionComponent } from "react";

export interface Props {
  code: string;
  onClose: () => void;
  dialogForCodes: string[];
}

export const TaxCodeHelpDialog: FunctionComponent<Props> = ({ code, children, onClose, dialogForCodes }) => {
  const { i18n } = useLingui();
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    if (!isOpen && dialogForCodes.indexOf(code) > -1) {
      const needsToOpen = window.confirm(i18n._(t`Het in aanmerking te nemen bedrag berekenen?`));
      setIsOpen(needsToOpen);
    }
  }, [code, dialogForCodes, i18n, isOpen, setIsOpen]);

  if (!isOpen) {
    return null;
  }
  return (
    <Portal>
      <div className="hulpscherm">
        <div className="hulpschermclose">
          <button onClick={onClose}>x</button>
        </div>

        <div className="hulpschermtitel">
          <Trans>Code {code}</Trans>
        </div>
        <div className="content">{children}</div>
      </div>
    </Portal>
  );
};

TaxCodeHelpDialog.displayName = "TaxCodeHelpDialog";
